module.exports = __webpack_public_path__ + "img/outreach_squ.0815d85b.jpg";